<template>
  <div class="edit-table">
    <el-button @click="cellClick">查看合同表单</el-button>
    <Modal
      :modalConfig.sync="modalConfig"
      :visible.sync="modalConfig.visible"
      style="z-index:2000"
      @onClose="closeModal"
    >
      <component :is="formName" ref="modalForm" @onClose="closeModal" :formConfig="formConfig" />
      <div class="dialog-footer">
        <el-button icon="el-icon-close" type="danger" @click="closeModal">关闭</el-button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/found/components/modal';
import FormPage from '../../contractManagement/form/index';

export default {
  name: 'apply',
  components: {
    Modal,
    FormPage,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalConfig: {
        width: '80%',
        title: '标题',
        type: 'Full',
        visible: false,
      },
      formName: '',
      formConfig: {},
    };
  },
  watch: {
    value() {
      this.formConfig = this.value;
    },
  },
  created() {

  },
  methods: {
    // 查看详情
    cellClick() {
      this.formName = 'FormPage';
      this.modalConfig.title = '查看';
      this.formConfig = {
        ...this.formConfig,
        code: 'view',
      };
      this.modalConfig.visible = true;
    },
    closeModal() {
      this.modalConfig.visible = false;
    },
  },
};
</script>

<style lang="less" scepod>
.edit-table{
    margin-left: 60px;
}
</style>
